import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { 
  Play, 
  Users, 
  Bot, 
  Clock, 
  Gamepad2, 
  Zap, 
  Target,
  BookOpen,
  ChevronRight
} from "lucide-react";

// Remove features that are not implemented - clean up code
interface QuickStartSectionProps {
  onQuickPlay: () => void;
  onPlayComputer: () => void;
  onSolvePuzzle: () => void;
}

export function QuickStartSection({ 
  onQuickPlay, 
  onPlayComputer, 
  onSolvePuzzle 
}: QuickStartSectionProps) {

  const guestFeatures = [
    "No registration required",
    "Multiple AI difficulty levels", 
    "Save progress later",
    "Perfect for learning"
  ];

  return (
    <div className="space-y-8">
      {/* Guest Play CTA */}
      <Card className="max-w-2xl mx-auto text-center bg-gradient-to-r from-teal-100 via-emerald-50 to-cyan-100 dark:from-teen-gold/10 dark:to-teen-purple/10 border border-primary/30 dark:border-teen-gold/20">
        <CardContent className="p-6">
          <div className="space-y-4">
            <div className="text-3xl">👋</div>
            <h4 className="text-xl font-bold text-foreground">
              New Here? Challenge Our AI!
            </h4>
            <p className="text-muted-foreground">
              Jump in immediately - no signup required! Start with our friendly AI opponents.
            </p>
            
            <div className="grid grid-cols-2 gap-2 text-sm text-muted-foreground">
              {guestFeatures.map((feature, index) => (
                <div key={index} className="flex items-center gap-2">
                  <div className="w-1.5 h-1.5 bg-teen-gold rounded-full"></div>
                  {feature}
                </div>
              ))}
            </div>

            <Button 
              onClick={onPlayComputer}
              data-tour="play-button"
              className="bg-teen-gold hover:bg-teen-gold/90 text-white font-semibold px-8 py-3 rounded-xl shadow-teen-gold hover:scale-105 transition-all duration-300"
            >
              <Bot className="w-5 h-5 mr-2" />
              Challenge AI! 🤖
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}